/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: accordion
 | -------------------------------------------------------------
 |
 |  Functionality for accordions.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const accordions = document.querySelectorAll('.mgbdes__accordion')
const accordionsAllItems = [...document.querySelectorAll('[data-accordion-item]')]

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

/**
 * Get the height of the content of the inner accordion
 * @param  {HTMLElement} accordionItem The tab of the accordion
 * @return {Number} Accordion content's height in px value
 */
const getContentHeight = accordionItem => {
  const accordionInner = accordionItem.querySelector('[data-accordion-inner]')
  return accordionInner.getBoundingClientRect().height
}

/**
 * Close the accordion item, set aria-expanded to false and focus back to button and hide content
 * @param  {HTMLElement} accordionItem The tab of the accordion
 */
const closeAccordion = accordionItem => {
  const accordionItemButton = accordionItem.querySelector('button')
  const accordionContent = accordionItem.querySelector('[data-accordion-content]')

  accordionItem.classList.remove('is-active')
  accordionContent.style.height = 0

  // return focus to parent element on close
  accordionItemButton.focus()

  // set aria expanded false on closing current button
  accordionItemButton.setAttribute('aria-expanded', false)
}

/**
 * Open the accordion item, set aria-expanded to true and reveal content
 * @param  {HTMLElement} accordionItem The tab of the accordion
 */
const openAccordion = accordionItem => {
  const accordionItemButton = accordionItem.querySelector('button')
  const accordionContent = accordionItem.querySelector('.accordion__content')

  accordionContent.style.height = `${getContentHeight(accordionItem)}px`
  accordionItem.classList.add('is-active')

  // set aria expanded true on opening current button
  accordionItemButton.setAttribute('aria-expanded', true)
}

/**
 * Check if the accordion item is active and return true or false
 * @param  {HTMLElement} accordionItem The tab of the accordion
 * @return {Boolean} either true or false
 */
const isAccordionOpen = accordionItem => {
  return accordionItem.classList.contains('is-active')
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

// check if there are any accordios on the page
if (accordions.length > 0) {
  // add unique id's to ALL accordion item buttons and related content on the page
  accordionsAllItems.forEach((item, index) => {
    const accordionItemButton = item.querySelector('[data-accordion-title]')
    const accordionItemContent = item.querySelector('[data-accordion-content]')

    // loop through the items and add an id to the buttons and the content
    accordionItemButton.setAttribute('id', `accordion-title${index + 1}`)
    accordionItemContent.setAttribute('id', `item${index + 1}`)

    // add aria-controls and aria-labelledby to buttons and the content to relate them
    accordionItemButton.setAttribute('aria-controls', `item${index + 1}`)
    accordionItemContent.setAttribute('aria-labelledby', `accordion-title${index + 1}`)
  })

  // add click event
  // check if an accordion is present on page, if yes, loop through each single accordion
  accordions.forEach(accordion => {
    const accordionContainer = accordion.querySelectorAll('[data-accordion]')
    // add the event listener for every individual accordion
    accordionContainer.forEach(item => {
      item.addEventListener('click', event => {
        const accordionItem = event.target.closest('[data-accordion-item]')
        if (!accordionItem) return

        isAccordionOpen(accordionItem)
          ? closeAccordion(accordionItem)
          : openAccordion(accordionItem)
      })
    })
  })

  // add keyboard event escape to close an accordion item
  document.addEventListener('keydown', event => {
    const accordionItem = event.target.closest('[data-accordion-item]')

    // 1. if pressed key is not Escape, return and exit
    if (event.key !== 'Escape') return
    // 2. if focus is not inside the accordion, return and exit
    if (!accordionItem) return

    // if 1 and 2 are true, then check if the current accorion item is open, if so, close it
    if (isAccordionOpen(accordionItem)) {
      closeAccordion(accordionItem)
    }
  })

  // add keyboard event arrow navigation to navigate between arrow items
  document.addEventListener('keydown', event => {
    // 1. if focus is not on the accordion items button, return and exit
    if (!event.target.closest('[data-accordion-title]')) return

    // if 1 is true, continue and select all accordion items in an array
    const accordionContainer = event.target.closest('[data-accordion]')
    const accordionItem = event.target.closest('[data-accordion-item]')
    const accordionItems = [...accordionContainer.querySelectorAll('[data-accordion-item]')]
    const index = accordionItems.findIndex(element => element === accordionItem)

    // set key property in variable
    const { key } = event
    // set the target item
    let targetItem

    // use key to see if arrow down is pressed, if so, move index down
    if (key === 'ArrowDown') {
      targetItem = accordionItems[index + 1]
    }

    // use key to see if arrow up is pressed, if so, move index up
    if (key === 'ArrowUp') {
      targetItem = accordionItems[index - 1]
    }

    // if target item is a valid value of the array, set the focus to that item
    if (targetItem) {
      event.preventDefault()
      targetItem.querySelector('button').focus()
    }
  })
}
